import { IonIcon } from '@ionic/react'
import Entity from 'components/AddRemoveTableSortable/types/Entity'
import { createOutline, remove } from 'ionicons/icons'
import { useEffect } from 'react'
import ActionButtons from 'shared/components/ActionButtons'

interface useInitProps {
  rows: Array<any>
  handleExcludeRow: (row: Entity) => void
  disableActions: boolean
  handleModalRowEdit?: (row: Entity) => void
}

interface ActionProps {
  action: any
}

const useInit = (props: useInitProps) => {
  useEffect(() => {
    props.rows.forEach((row: Entity & ActionProps, index: number, dataArray: any) => {
      const buttons: Array<any> = []
      if (props.handleModalRowEdit !== undefined) {
        buttons.push({
          content: (
            <a
              className={'info'}
              style={{ pointerEvents: props.disableActions ? 'none' : 'auto' }}
              role='button'
              href='#'
              title='Edit'
              onClick={(e) => {
                if (!props.disableActions) {
                  e.preventDefault()
                  if (props.handleModalRowEdit !== undefined) {
                    props.handleModalRowEdit(row)
                  }
                }
              }}
            >
              <IonIcon icon={createOutline} className='ionicon' style={{ fontSize: '16px' }} />
            </a>
          ),
        })
      }

      buttons.push({
        content: (
          <a
            className={'danger'}
            style={{ pointerEvents: props.disableActions ? 'none' : 'auto' }}
            role='button'
            href='#'
            title='Remove'
            onClick={(e) => {
              if (!props.disableActions) {
                e.preventDefault()
                props.handleExcludeRow(row)
              }
            }}
          >
            <IonIcon icon={remove} className='ionicon' style={{ fontSize: '16px' }} />
          </a>
        ),
      })

      row.action = <ActionButtons buttons={buttons} />
    })
  }, [props.rows])
}

export default useInit
